import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { Flexbox, FlexboxColumn } from '../../components/action/Flexbox';
import Logo from '../../components/Logo/Logo';
import ThemedText from '../../components/theme/ThemedText';
import { resources } from '../../constants';
import { TopTakesRowSkeleton } from './Profiles';

// You should already have these imported somewhere
// import { getProvider } from './your-provider-logic';
// import { cacheCall, id, dateMillis } from './your-cache-utils';



export function EnsRow({ data, onClick }) {
  return (
    <FlexboxColumn className='pointer' alignItems='flex-start' gap='0.5rem' onClick={() => onClick(data)}>
      <Flexbox gap='0.25rem'>
        <Logo width={'1rem'} height={'1rem'} borderRadius='50%' src={data?.avatar || resources.img.getAvatar(data?.address)} />
        <ThemedText.H6 weight='semi-bold'>{data?.name}</ThemedText.H6>
      </Flexbox>
      <Flexbox gap='0.5rem'>
        <ThemedText.H6 color='color-xlight'>{data?.address}</ThemedText.H6>
      </Flexbox>
    </FlexboxColumn>
  );
}

const ensData = [
  {
    avatar: null,
    name: 'zeropants.eth',
    address: '0x614d98a57a5d879d717152de0690ed2b04562ade',
  },
  {
    avatar: null,
    name: 'degenpaws.eth',
    address: '0x691743ddfe003f6a0c131f3dcd165d53e7122be6',
  },
  {
    avatar: null,
    name: 'dubstepnerd.eth',
    address: '0xa00b0540f43e00a634d016a31b0a39d95170e6bf',
  },
  {
    avatar: 'https://i.ibb.co/M7mj9Y2/chudd.jpg',
    name: 'chud.eth',
    address: '0xb4fb31e7b1471a8e52dd1e962a281a732ead59c1',
  },
  {
    avatar: null,
    name: 'defiremora.eth',
    address: '0x1914717974224765b85636159d48f46dbbdbde27',
  },
  {
    avatar: null,
    name: 'kemaboss.eth',
    address: '0x737256e3b6cbb8ddf07d073c22b10bae09c08082',
  },
  {
    avatar: null,
    name: '4aaaa.eth',
    address: '0x89d3afde089399534afdb7ad2d05138315ef45ff',
  },
  {
    avatar: 'https://arweave.net/TT_FxOz0hVfLpborXB1noP6dOdgZgyKcR2JEZrywfZA',
    name: 'honeywithmoney.eth',
    address: '0x5f8fb8e56e27951579806bfb04a651658aaf46e1',
  },
  {
    avatar: null,
    name: '0xduck1.eth',
    address: '0x3ff8788f9172d77a9688939bc00442c7be9042bf',
  },
  {
    avatar: 'https://euc.li/alterac.eth',
    name: 'alterac.eth',
    address: '0x2385233abb910357e2b97a16d40e0443e53d0769',
  },
];

const EnsAvatars = ({ handleRedirect }) => {
  return (
    <FlexboxColumn alignItems='flex-start' gap='1.5rem'>
      <ThemedText.H5 weight='semi-bold'>Top ENS</ThemedText.H5>
      {!ensData && Array.from({ length: 5 }).map(() => <TopTakesRowSkeleton />)}
      {ensData?.map(taker => (
        <EnsRow onClick={handleRedirect} data={taker} />
      ))}
    </FlexboxColumn>
  );
};

export default EnsAvatars;
